export const MobileUserConstants = {
    CREATE_REQUEST: 'USERS_CREATE_REQUEST',
    CREATE_SUCCESS: 'USERS_CREATE_SUCCESS',
    CREATE_FAILURE: 'USERS_CREATE_FAILURE',

    // CREATEUSER_REQUEST: 'DETAILS_CREATE_REQUEST',
    // CREATEUSER_SUCCESS: 'DETAILS_CREATE_SUCCESS',
    // CREATEUSER_FAILURE: 'DETAILS_CREATE_FAILURE',

    UPDATE_REQUEST: 'USERS_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'USERS_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'USERS_UPDATE_FAILURE',

    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',

    DELETE_REQUEST: 'USERS_DELETE_REQUEST',
    DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
    DELETE_FAILURE: 'USERS_DELETE_FAILURE',

    GETROLEDDL_REQUEST: 'ROLE_DDL_REQUEST',
    GETROLEDDL_SUCCESS: 'ROLE_DDL_SUCCESS',
    GETROLEDDL_FAILURE: 'GETROLEDDL_FAILURE',

    GETWDDL_REQUEST: 'GETWDDL_REQUEST',
    GETWDDL_SUCCESS: 'GETWDDL_SUCCESS',
    GETWDDL_FAILURE: 'GETWDDL_FAILURE',

     GETSDDL_REQUEST: 'GETSDDL_REQUEST',
    GETSDDL_SUCCESS: 'GETSDDL_SUCCESS',
    GETSDDL_FAILURE: 'GETSDDL_FAILURE',
    
    ISACTIVE_REQUEST: 'USER_ISACTIVE_REQUEST',
    ISACTIVE_SUCCESS: 'USER_ISACTIVE_SUCCESS',
    ISACTIVE_FAILURE: 'USER_ISACTIVE_FAILURE',

    GETEXPORT_REQUEST: 'USER_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'USER_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'USER_GETEXPORT_FAILURE',
    
    DIALOG_REQUEST:'DIALOG_REQUEST',

    LOADING_REQUEST:'LOADING_REQUEST',

    DIALOG_ISACTIVE_REQUEST:'DIALOG_ISACTIVE_REQUEST'
};